export const SHOW_SUCCESS_MESSAGES = 'SHOW_SUCCESS_MESSAGES';
export const SHOW_ERROR_MESSAGES = 'SHOW_ERROR_MESSAGES';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';

